import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@domain-group/fe-co-icon';
import Carousel from '@domain-group/fe-allhomes-nuka-carousel';
import { AgentType } from '@domain-group/fe-allhomes-library';
import AgentCard from './carousel-agent-card';
import PrivateListerCard from './carousel-private-lister-card';
import * as styles from './agent-carousel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var buildControl = direction => _ref => {
  var previousSlide = _ref.previousSlide,
    nextSlide = _ref.nextSlide;
  var isLeft = direction === 'left';
  var Component = isLeft ? ChevronLeftIcon : ChevronRightIcon;
  return ___EmotionJSX(Component, {
    css: styles.arrows,
    onClick: isLeft ? previousSlide : nextSlide
  });
};
var AgentCarousel = _ref2 => {
  var _ref2$agents = _ref2.agents,
    agents = _ref2$agents === void 0 ? [] : _ref2$agents,
    _ref2$isAutoplay = _ref2.isAutoplay,
    isAutoplay = _ref2$isAutoplay === void 0 ? true : _ref2$isAutoplay,
    _ref2$beforeChange = _ref2.beforeChange,
    beforeChange = _ref2$beforeChange === void 0 ? () => {} : _ref2$beforeChange,
    _ref2$largePhoto = _ref2.largePhoto,
    largePhoto = _ref2$largePhoto === void 0 ? false : _ref2$largePhoto;
  var showArrows = agents.length > 1;
  return ___EmotionJSX(Carousel, {
    beforeSlide: beforeChange,
    decorators: showArrows ? [{
      component: buildControl('left'),
      position: 'CenterLeft',
      style: {
        top: largePhoto ? '80px' : '32px',
        left: largePhoto ? '-16px' : '0'
      }
    }, {
      component: buildControl('right'),
      position: 'CenterRight',
      style: {
        top: largePhoto ? '80px' : '32px',
        right: largePhoto ? '-16px' : '0'
      }
    }] : [],
    initialSlideHeight: 132,
    initialSlideWidth: 286,
    css: styles.carousel,
    autoplay: isAutoplay && showArrows,
    autoplayInterval: 5000,
    slidesToShow: 1,
    wrapAround: true
  }, agents.map(agent => {
    var Component = agent.agency.type === AgentType.PrivateLister.name ? PrivateListerCard : AgentCard;
    return ___EmotionJSX(Component, {
      key: "".concat(agent.name, "-").concat(agent.agency.name),
      agent: agent,
      largePhoto: largePhoto
    });
  }));
};
export default AgentCarousel;